import { InjectionToken } from '@angular/core';
import { Environment } from '../model/environment';

export const mbeConfigService = new InjectionToken<Environment>(
    'mbeEnvironmentConfig'
);
